import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import { PageContext } from "../../../../Context/PageContext";
import { ApiConnectEmailConfirm, ApiConnectLogRegister, ApiConnectVipRequest } from "../../../../api/LionsUserApiConect";
import PopUpWarning, { PopUpCaller } from "../../../../PopUpWarning/PopUpWarning";
import VipRequestSuccess from "./VipRequestSuccess";
import EmailMessageVipRequest from "../../../../EmailConfirmFormulary/EmailMessageVipRequest";
import PopUpImg from "../img/wallpaper_60_1024.png"

function VipRequestForm(){

    const { user, setPopMenuContent, setDashboardPageSelection, userAccessList } = useContext(PageContext);

    const { register, getValues} = useForm();

    const [submitButtonColor, setSubmitButtonColor] = useState("rgba(112, 118, 113, 0.5)");
    const [availableSubmit, setAvailableSubmit] = useState("none");
    const [planName, setPlanName] = useState("");
    const [donationValue, setDonationValue] = useState(0);
    const [vipDays, setVipDays ] = useState(0);
    const [accessName, setAccessName] = useState("")


    function rulesValidationCheck(){

        setAccessName(getValues('access'));
        setPlanName(getValues('plan'));

        if(getValues('plan') === "ANGELING"){
        setDonationValue(15);
        setVipDays(10);}
        else if(getValues('plan') === "GTB"){
        setDonationValue(25);
        setVipDays(20);}
        else if(getValues('plan') === "IFRIT"){
        setDonationValue(30);
        setVipDays(30); }


        if(getValues('rulesCheck') === false || getValues('plan') == "" || getValues('access') == "" ) {
            setSubmitButtonColor("rgba(112, 118, 113, 0.5)");
            setAvailableSubmit("none");
            return;
        } else { 
            setSubmitButtonColor("rgba(28, 160, 46, 1)");
            setAvailableSubmit("auto");
        };
        return;
    }

    function requestDonation() {

        if(getValues('rulesCheck') === false || getValues('plan') === "" || getValues('access') === "" ){
            return;
        }

        const agora = new Date();
        const hora = agora.getHours();
        const Minuto = agora.getMinutes();
        const Segundo = agora.getSeconds();
        const ano = agora.getFullYear();
        const mes = (agora.getMonth() + 1).toString().padStart(2, '0');
        const dia = agora.getDate().toString().padStart(2, '0');
        const dataApiFormat = `${ano}${mes}${dia}${hora}${Minuto}${Segundo}`;


        let DtoVipRequest = {

        id: 0,
        planName: getValues('plan'),
        userId: getValues('access'),
        requestStatus: "Aguardando Pagamento",
        requestCode: dataApiFormat,
        eventDate: null,
        paymentlink: null,
        userEmail: user.userEmail,
        mercadoPaymentId: null

        }

        var negado = "Solicitação Negada! Houve algum problema com os dados inseridos. Tente novamente."
        var requestedAlready = "Já existe uma solicitação em andamento para essa conta..<br>Só é possível realizar uma solicitação por acesso de cada vez."

        let result = ApiConnectVipRequest(DtoVipRequest)
        result.then((response) => {
            if(response === "waiting payment") { 
                PopUpCaller(requestedAlready,"rgba(92, 95, 98, 0.8)", 10000);

            } else if(response === false) { 
                PopUpCaller(negado,"rgba(191, 18, 18, 0.8)", 10000);

            } else {
                ApiConnectLogRegister(user, `Solicitou acesso VIP: Plano ${DtoVipRequest.planName} login: ${DtoVipRequest.userId} código ${DtoVipRequest.requestCode} em : `);

                setPopMenuContent(<VipRequestSuccess code={dataApiFormat} paymentLink={response.paymentlink}/>);

                window.open(response.paymentlink, '_blank', 'noopener,noreferrer');

            }
        })

    }



    return(
        <MasterContainer>
        <VipRequestMaster>
            <PopUpWarning />

            <TitleMaster>
                <h1>Solicitação de acesso Vip</h1>
                <span>Confirme <b>o valor da Doação</b>, o plano <b>Vip selecionado</b>, assim como <b>a conta</b> em que deseja receber o acesso Vip:<br/><br/>
                <b>Atenção:</b> Por favor, selecione os campos com atenção e confira os dados da solicitação na seção RESUMO. Após finalizar o procedimento não haverá como alterar os dados.<br/>
                </span>
            </TitleMaster>

            <Label for="planList">Escolha um Plano:</Label>
            <Select id="planList"  {...register('plan', {
                onChange: () => rulesValidationCheck()
            })}>
                <option value="" selected>-- Por favor, escolha uma opção --</option>
                <option value="ANGELING">Plano I - Angeling - Doação: R$15,00</option>
                <option value="GTB">Plano II - GTB - Doação: R$25,00</option>
                <option value="IFRIT">Plano III - Ifrit - Doação: R$30,00</option>
            </Select>


            <Label for="accessList">Selecione o acesso que receberá o período Vip:</Label>
            <Select id="accessList" {...register('access',
                { onChange: () => rulesValidationCheck()
            })
            }>
                <option value="" selected>-- Por favor, escolha uma opção --</option>

               {userAccessList.map((item) => {
                let vipAtivo = "";
                let diasVip = "";

                if(item.group_id <= 0){ 
                    vipAtivo = "Não"; diasVip = ""

                    return (
                    <option value={item.userid}> {item.userid}  - Vip Ativo: {vipAtivo} {diasVip}</option>
                    )
                }
                else { vipAtivo = "Sim"; diasVip = " / Dias restantes: " + item.vip_time
                return (
                    <option value={item.userid} disabled>{item.userid}  - Vip Ativo: {vipAtivo} {diasVip}</option>
                )}
               })}

            </Select>

            
            <ResumeMaster>
                <Legend>Resumo</Legend>

            <Clause> <span>Plano selecionado: <b>{planName}</b></span> </Clause>
            <Clause> Valor da Doação: <b>R${donationValue},00</b> </Clause>
            <Clause> Período Vip: <b>{vipDays} Dias</b> </Clause>
            <Clause> Acesso: <b>{accessName}</b> </Clause>


            </ResumeMaster>

            <CheckBoxContainer>
                <Input type="checkbox" {...register('rulesCheck',
                     { onChange: () => rulesValidationCheck()}
                )}
                />
                <span> Li e estou de acordo com todas as regras e condições de Doação e acesso Vip.</span>
            </CheckBoxContainer>

            <ConfirmInput
                    color={submitButtonColor}
                    onClick={() => {
                        requestDonation();}
                    }
                    value="Confirmar e Solicitar"
                    available={availableSubmit}
                    />

        </VipRequestMaster>

        <BgPopUp bgp={PopUpImg}/>
        </MasterContainer>
    )
}

export default VipRequestForm;

const VipRequestMaster = styled.div`
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 10px;
    width: 600px;
    height: 800px;
    //border: solid 1px black;
    //box-shadow: 10px 10px 10px 0px black;
`

const TitleMaster = styled.div`
    width: 500px;
    //border: solid;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: justify;
    margin-bottom: 10px;

`

const ResumeMaster = styled.fieldset`
    width: 460px;
    border-top: solid 1px black;
    //border: none;
    padding: 0 20px;
    overflow: auto;
    margin-top: 0px;
    margin-bottom: 10px;

`

const Legend = styled.legend`
    font-size: 24pt;
    font-weight: bold;
    text-align: left;

`

const Clause = styled.div`
    text-align: left;
    margin-bottom: 14px;
    width: 460px;
    //border: solid;
`


const CheckBoxContainer = styled.div`
    width: 500px;
    //border: solid;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin-bottom: 10px;

`

const Input = styled.input`
    width: 25px;
    height: 25px;
    margin-right: 10px;
`

const ConfirmInput = styled.input`
    padding: 10px 5px;
    width: 200px;
    margin: 0px 0;
    border-radius: 5px;
    font-size: 14pt;
    border: none;
    background-color: ${props => props.color};
    color: white;
    transition: .3s ease-in-out;
    text-align: center;
    pointer-events: ${props => props.available};

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
    scale: 1.1;
    
    }
`

const Select = styled.select`
    padding: 10px 20px;
    font-size: 12pt;
    width: 500px;
    margin-bottom: 20px;
`

const Label = styled.label`
    padding: 10px 20px;
    font-size: 14pt;
    width: 500px;
    font-weight: bold;
`

const BgPopUp = styled.div`
    background-image: url(${props => props.bgp});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 525px;
    height: 730px;
    //border: solid;

    @media(max-width: 1000px) {
      background-image: url('');
      width: 0px;
    }
`

const MasterContainer = styled.div`
    display: flex;
    border: solid 1px;
    align-items: center;
    background-color: white;
    border-radius: 10px;
    box-shadow: 10px 10px 10px 0 black;
    height: 100%;
`